export const tabs = [
	{
		title: "Rate",
	},
	{
		title: "Delivery Time",
	},
	{
		title: "Preferred",
	},
];

export const initialCarrierSelectionValues = {
	selected: -1,
	expanded: -1,
	globalMargin: {
		marginType: "",
		marginValue: 0,
	},
	applyGlobalMargin: false,
	modalToRender: "",
	carrierFilter: {
		quoteType: "",
		serviceLevels: "",
		serviceTypes: "",
	},
};

export const carrierColDefs = [
	{ width: "125px" },
	{ width: "150px" },
	{ width: "125px" },
	{ width: "150px" },
	{ width: "125px" },
	{ width: "125px" },
	{ width: "125px" },
	{ width: "125px" },
	{ width: "125px" },
	{ width: "125px" },
];

export enum ServiceLevel {
	Standard = 1,
	Volume = 7,
	P44Pricing = 8,
	SMCPricing = 10,
}
